import React from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { PRECISION_POLICY_PATH } from '@utils/constants';
import globalStyles from '../index.less';

const PrecisionTab = () => (
    <NavLink
      id="tab-precision-policies"
      key="precision-policies"
      to={`${PRECISION_POLICY_PATH}`}
      className={classnames(globalStyles.tab)}
      activeClassName={globalStyles.active}
      exact
    >
      Policies
    </NavLink>
);

export default PrecisionTab;
